import { type SuiDataTableColumnType } from '@developers/scoro-ui';

export const TIMESHEET_SETTINGS_TABS = {
	TIMELOCKING_BULK_ACTIONS: 'timesheet-settings-timelocking-bulk-actions',
	TIMELOCKING: 'timesheet-settings-timelocking',
};

export const COL_DEFINITION: SuiDataTableColumnType[] = [
	{
		id: 'setting',
		width: '20rem',
		title: '',
		isInteractive: true,
	},
	{
		id: 'action',
		width: '2rem',
		title: '',
		isInteractive: true,
	},
];

export const MAX_REMINDERS = 5;

export const DEFAULT_REMINDER_TIME = '09:00';
export const DEFAULT_REMINDER_DAY = '1';

export const RECEIVER_TYPE = {
	GROUP: 'group',
	USER: 'user',
};
